import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=8e5f9b6e&"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports